import { parseDate } from "app/_sharedFuctions/shared-functions";
import { AssayCategory, molecular_kind_values, Roles, timesUnitsEnum, VetMolKind } from "./interfaces/operation-result-types";

export interface IAssayFormData {
    id?: string | null;
    code: string | null;
    name: string | null;
    category?: AssayCategory | null;
    abbreviation: string | null;
    reportName?: string | null;
    reportNameEnglish?: string | null;
    sectors: (string | null)[] | null;
    authorizedAnalysts: (string | null)[] | null;
    supervisors: (string | null)[] | null;
    matrixId: string | null;
    methodId: string | null;
    active: boolean | null;
    kind: string | null;
    formKind: (VetMolKind | null)[] | null;
    reportKind: string | null;
    observations: string | null;
    excluded: boolean | null;
    v_: number
    matrix_v2Ids: (string)[] | null,
    multi_humidity_adjustment: boolean | null,
    derived : boolean,
    derivedFrom: Date | null,
    derivedTill: Date | null,
    bioGroupId : string | null,
    supplier: string | null,
    groupConclusions: boolean | null,
    molecular_kind: molecular_kind_values | null
    assayGroupsIds: string[]
    adminConfig: AssayAdminConfig
    defaultResult?: string | null
    defaultCualResult?: string | null
    individualLabel: boolean | null
    externalValidation: boolean | null
    externalValidationSource: string | null
    z_index: number | null;
    autoValidationRoles?: Roles[];
    preparation_info?: string
  }

  export interface AssayAdminConfig {
    timePerReplication: number | null;
    greenDays: number | null;
    yellowDays: number | null;
    redDays: number | null;
    time_unit: timesUnitsEnum | null
  }

  export class Assay implements IAssayFormData {

    id?: string;
    code: string;
    name: string;
    abbreviation: string;
    category?: AssayCategory | null;
    reportName?: string;
    reportNameEnglish?: string;
    sectors: string[];
    authorizedAnalysts: string[];
    supervisors: string[];
    matrixId: string;
    methodId: string;
    active: boolean;
    kind: string;
    formKind: VetMolKind[];
    reportKind: string;
    observations: string;
    excluded: boolean;
    v_: number;
    matrix_v2Ids: string[];
    multi_humidity_adjustment: boolean;
    derived: boolean;
    derivedFrom: Date;
    derivedTill: Date;
    bioGroupId: string;
    supplier: string;
    groupConclusions: boolean;
    molecular_kind: molecular_kind_values;
    assayGroupsIds: string[];
    adminConfig: AssayAdminConfig;
    defaultResult?: string | null;
    defaultCualResult?: string | null
    individualLabel: boolean | null
    externalValidation: boolean | null
    externalValidationSource: string | null
    z_index: number | null;
    autoValidationRoles?: Roles[];
    preparation_info? : string;


    constructor(data: IAssayFormData) {
      this.id = data.id;
      this.code = data.code;
      this.name = data.name;
      this.abbreviation = data.abbreviation;
      this.category = data.category;
      this.reportName = data.reportName;
      this.reportNameEnglish = data.reportNameEnglish;
      this.sectors = data.sectors;
      this.authorizedAnalysts = data.authorizedAnalysts;
      this.supervisors = data.supervisors;
      this.matrixId = data.matrixId;
      this.matrix_v2Ids = data.matrix_v2Ids;
      this.methodId = data.methodId;
      this.active = data.active;
      this.kind = data.kind;
      this.formKind = data.formKind;
      this.reportKind = data.reportKind;
      this.observations = data.observations;
      this.excluded = data.excluded;
      this.v_ = data.v_;
      this.multi_humidity_adjustment = data.multi_humidity_adjustment;
      this.derived = data.derived;
      this.derivedFrom = parseDate(data.derivedFrom, '00:00:00');
      this.derivedTill = parseDate(data.derivedTill, '23:59:59');
      this.bioGroupId = data.bioGroupId;
      this.supplier = data.supplier;
      this.groupConclusions = data.groupConclusions;
      this.molecular_kind = data.molecular_kind;
      this.assayGroupsIds = data.assayGroupsIds;
      this.adminConfig = new AssayAdminConfig(data.adminConfig);
      this.defaultResult = data.defaultResult;
      this.defaultCualResult= data.defaultCualResult
      this.individualLabel = data.individualLabel
      this.externalValidation = data.externalValidation
      this.externalValidationSource = data.externalValidationSource
      this.z_index = data.z_index ? +data.z_index : undefined
      this.autoValidationRoles = data.autoValidationRoles
      this.preparation_info = data.preparation_info ? JSON.stringify(data.preparation_info) : undefined
    }

  }

  export class AssayAdminConfig implements AssayAdminConfig {
    timePerReplication: number | null;
    greenDays: number | null;
    yellowDays: number | null;
    redDays: number | null;
    time_unit: timesUnitsEnum | null

    constructor(data: AssayAdminConfig) {
      this.timePerReplication = data.timePerReplication;
      this.greenDays = this.validateIsNaN(data.greenDays);
      this.yellowDays = this.validateIsNaN(data.yellowDays);
      this.redDays = this.validateIsNaN(data.redDays);
      this.time_unit = data.time_unit
    }
    validateIsNaN (value: string | number | null) {
      if(isNaN(+value)) return 0
      return +value
    }
  }
